module.exports = __webpack_public_path__ + "static/media/1008285.fe742db9.png";